<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <BannerForm @submit-requested="submitRequested"></BannerForm>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import BannerForm from './BannerForm.vue'

export default {
  components: { BannerForm },
  methods: {
    ...mapActions('banners', ['postBanner']),
    submitRequested (input) {
      this.postBanner(input);
    },
  }
}
</script>
